var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryEdu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "history_edu"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_523_2682",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_523_2682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "history_edu_2",
    d: "M8 20C7.45 20 6.97917 19.8042 6.5875 19.4125C6.19583 19.0208 6 18.55 6 18V15H9V12.75C8.41667 12.7167 7.8625 12.5875 7.3375 12.3625C6.8125 12.1375 6.33333 11.8 5.9 11.35V10.25H4.75L1.5 7C2.1 6.23333 2.84167 5.69167 3.725 5.375C4.60833 5.05833 5.5 4.9 6.4 4.9C6.85 4.9 7.2875 4.93333 7.7125 5C8.1375 5.06667 8.56667 5.19167 9 5.375V4H21V17C21 17.8333 20.7083 18.5417 20.125 19.125C19.5417 19.7083 18.8333 20 18 20H8ZM11 15H17V17C17 17.2833 17.0958 17.5208 17.2875 17.7125C17.4792 17.9042 17.7167 18 18 18C18.2833 18 18.5208 17.9042 18.7125 17.7125C18.9042 17.5208 19 17.2833 19 17V6H11V6.6L17 12.6V14H15.6L12.75 11.15L12.55 11.35C12.3167 11.5833 12.0708 11.7917 11.8125 11.975C11.5542 12.1583 11.2833 12.3 11 12.4V15ZM5.6 8.25H7.9V10.4C8.1 10.5333 8.30833 10.625 8.525 10.675C8.74167 10.725 8.96667 10.75 9.2 10.75C9.58333 10.75 9.92917 10.6917 10.2375 10.575C10.5458 10.4583 10.85 10.25 11.15 9.95L11.35 9.75L9.95 8.35C9.46667 7.86667 8.925 7.50417 8.325 7.2625C7.725 7.02083 7.08333 6.9 6.4 6.9C6.06667 6.9 5.75 6.925 5.45 6.975C5.15 7.025 4.85 7.1 4.55 7.2L5.6 8.25ZM15 17H8V18H15.15C15.1 17.85 15.0625 17.6917 15.0375 17.525C15.0125 17.3583 15 17.1833 15 17Z",
    fill: "#00A3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryEdu);
export default __webpack_public_path__ + "static/media/history_edu.72e0ff4b0106318084af333daa72666e.svg";
export { ForwardRef as ReactComponent };